import createReducer from '../../utils/createReducer';
import * as constants from './constants';

const initialState = {
  isFetching: false,
  errorMessage: null,
  saveSuccess: false,
  data: null,
};

export default createReducer(initialState, {
  [constants.GET_SETTINGS_REQUEST](state, action) {
    const { isFetching } = action;
    return Object.assign({}, state, {
      isFetching,
    });
  },

  [constants.GET_SETTINGS_FAILURE](state, action) {
    const { isFetching, errorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
    });
  },

  [constants.GET_SETTINGS_SUCCESS](state, action) {
    const { isFetching, errorMessage, data } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
      data,
    });
  },

  [constants.SAVE_SETTINGS_REQUEST](state, action) {
    const { isFetching, saveSuccess } = action;
    return Object.assign({}, state, {
      isFetching,
      saveSuccess,
    });
  },

  [constants.SAVE_SETTINGS_FAILURE](state, action) {
    const { isFetching, errorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
    });
  },

  [constants.SAVE_SETTINGS_SUCCESS](state, action) {
    const { isFetching, errorMessage, saveSuccess, data } = action;
    return Object.assign({}, state, {
      isFetching,
      errorMessage,
      saveSuccess,
      data,
    });
  },
});



// WEBPACK FOOTER //
// ./src/containers/Settings/reducer.js